import { HttpInterceptors } from "./http.interceptor";

export class AccountService extends HttpInterceptors {
	async listAccount (filters) {
		const response = await this.axios.get("account/listAccount", { params: { filters } });
		return response.data;
	}

	async upsertAccount (payload) {
		const response = await this.axios.post("account/upsertAccount", payload);
		return response.data;
	}

	async deleteAccount (id) {
		const response = await this.axios.delete("account/deleteAccount", { params: id });
		return response.data;
	}
}
